import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <motion.h2
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        About Us
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        Welcome to our tour and travel company! We are passionate about helping you explore the world and create unforgettable memories.
        Our team of experienced travel experts is dedicated to crafting personalized itineraries that cater to your unique interests and preferences.
        Whether you're seeking a thrilling adventure, a relaxing beach getaway, or a cultural immersion experience, we have the perfect destination for you.
        Contact us today to start planning your next dream vacation!
      </motion.p>
    </div>
  );
};

export default About;
